<p style="margin: 20px; word-wrap: break-word;">
    {{ text }}
</p>

